import { Link } from "react-router-dom";

const CRM_PORTAL_URL =
  process.env.REACT_APP_CRM_PORTAL_URL || "https://portal.comfile.in/w/comfile/portal";

const FOOTER_GROUPS = [
  {
    title: "Usage",
    links: [
      { label: "Terms & Conditions", to: "/terms" },
      { label: "Privacy Policy", to: "/privacy" },
      { label: "Refund Policy", to: "/refund" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Confidentiality Policy", to: "/confidentiality" },
      { label: "Disclaimer Policy", to: "/disclaimer" },
    ],
  },
];

export default function PublicFooter() {
  return (
    <footer className="border-t border-slate-200 bg-[#FBF7F6] py-10">
      <div className="mx-auto grid max-w-7xl gap-8 px-4 sm:px-6 md:grid-cols-[1.2fr_1fr_1fr]">
        <div>
          <Link to="/" data-testid="footer-brand-link" aria-label="Comfile home">
            <img src="/comfile-logo.svg" alt="Comfile" className="h-12 w-40 object-contain object-left" />
          </Link>
          <p className="mt-2 max-w-xs text-sm text-slate-600">
            Accounting, tax and business compliance services.
          </p>
          <div className="mt-4 flex flex-wrap gap-x-5 gap-y-2 text-sm">
            <Link to="/#contact" className="text-slate-600 hover:text-[#C83D43] hover:underline" data-testid="footer-contact-link">
              Contact
            </Link>
            <a href={CRM_PORTAL_URL} className="font-medium text-[#C83D43] hover:underline" data-testid="footer-client-login-link">
              Client login
            </a>
          </div>
        </div>
        {FOOTER_GROUPS.map((group) => (
          <nav key={group.title} aria-label={`${group.title} links`} data-testid={`footer-${group.title.toLowerCase()}-links`}>
            <h2 className="font-heading text-base font-bold text-[#1D3970]">{group.title}</h2>
            <ul className="mt-3 space-y-2">
              {group.links.map(({ label, to }) => (
                <li key={to}>
                  <Link to={to} className="text-sm text-slate-600 hover:text-[#C83D43] hover:underline">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        ))}
      </div>
      <p className="mx-auto mt-8 max-w-7xl px-4 text-xs text-slate-500 sm:px-6">
        © {new Date().getFullYear()} Comfile
      </p>
    </footer>
  );
}
